import React from 'react';
// import { ShowIf} from 'components/utils';
import { Text } from 'components/tt-forms/common';
import DoiTuongKienNghi from './DoiTuongKienNghi.jsx';
import ToChucLienQuan from './ToChucLienQuan.jsx';
import {RowItemDoiTuongThanhTra, RowItemDoiTuongThanhTraView} from 'modules/theo-doi-thuc-hien/datatable';
import { header } from 'constants/table';
import {ThanhTra} from 'api';
import { Toastr } from 'modules/toastr';
import DataTable from 'components/data-table';

class NoiDungKienNghi extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      showDoiTuongKienNghi: false,
      showToChucLienQuan: false,
      type: this.props.type,
      id: this.props.id,
      idEdit: '',
      titleDialog: '',

      kienNghi: {
        tongToChucKienNghiXuLyHanhChinh: 0,
        tongCaNhanKienNghiXuLyHanhChinh: 0,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
        tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
        tongSaiPhamVeTienKienNghiXuLyKhac: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
      },

      theoDoi: {
        tongToChucKienNghiXuLyHanhChinh: 0,
        tongCaNhanKienNghiXuLyHanhChinh: 0,
        tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
        tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
        tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
        tongSaiPhamVeTienKienNghiXuLyKhac: 0,
        tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0
      },

      listDoiTuongThanhTra: this.props.listDoiTuongThanhTra,
      dataDoiTuongViPham: [],
      dataCoQuanToChuc: []
    }
  }

  componentDidMount() {
    this.getListDaTaDoiTuongViPham();
    this.getListDaTaCoQuanToChuc();
    this.props.onRef(this)
  }

  componentWillUnmount() {
    this.props.onRef(undefined)
  }

  getListDaTaDoiTuongViPham(type) {
    ThanhTra.actions.getDoiTuongViPham.request({cuocThanhTraId: this.state.id, loaiDoiTuongTheoDoi: 'DOI_TUONG_THEO_DOI'}).then(res => {
      if(res.data._embedded) {
        this.state.dataDoiTuongViPham = res.data._embedded.doiTuongViPhams
        this.setState({
          ...this.state
        },() => {
          this.checkSumTheoDoi();
          this.checkSumKienNghi();
          this.checkAllowKetThucTheoDoi();
        })
      } else {
        this.state.dataDoiTuongViPham = []
        this.setState({
          ...this.state
        },() => {
          this.checkSumTheoDoi();
          this.checkSumKienNghi();
          this.checkAllowKetThucTheoDoi();
        })
      }
    })
  }

  getListDaTaCoQuanToChuc() {
    ThanhTra.actions.getDoiTuongViPham.request({cuocThanhTraId: this.state.id, loaiDoiTuongTheoDoi: 'CO_QUAN_TO_CHUC_LIEN_QUAN'}).then(res => {
      if(res.data._embedded) {
        this.state.dataCoQuanToChuc = res.data._embedded.doiTuongViPhams
        this.setState({
          ...this.state
        },() => {
          this.checkSumTheoDoi();
          this.checkAllowKetThucTheoDoi();
        })
      } else {
        this.state.dataCoQuanToChuc = []
        this.setState({
          ...this.state
        },() => {
          this.checkSumTheoDoi();
          this.checkAllowKetThucTheoDoi();
        })
      }
    })
  }

  checkAllowKetThucTheoDoi() {
    let dataDoiTuongViPham = [...this.state.dataDoiTuongViPham];
    let dataCoQuanToChuc = [...this.state.dataCoQuanToChuc];
    let dataDoiTuongViPhamFilter = dataDoiTuongViPham.filter(state => {
      return state.tienDo != 'HOAN_THANH'
    })
    let dataCoQuanToChucFilter = dataCoQuanToChuc.filter(state => {
      return state.tienDo != 'HOAN_THANH'
    })

    if(dataCoQuanToChucFilter.length === 0 & dataDoiTuongViPhamFilter.length === 0) {
      this.props.setEnableKetThuc(true);
    } else {
      this.props.setEnableKetThuc(false);
    }
  }

  clearDataContain(name) {
    let data = [...this.state.dataDoiTuongViPham];
    let dataFilter = data.filter(item => {
      return name == item.ten
    })

    if(dataFilter.length > 0) {
      let params = {doiTuongViPhams: []}
      dataFilter.map(item => {
        params.doiTuongViPhams[params.doiTuongViPhams.length] = {
          id: item.doiTuongViPhamId
        }
      })
      ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
        Toastr('Xóa đối tượng vi phạm thành công', 'success');
        this.getListDaTa();
      });
    } else {
      Toastr('Dữ liệu không tồn tại', 'error');
    }
  }


  resetData() {
    let params = {doiTuongViPhams: []}
    this.state.dataDoiTuongViPham.map(item => {
      params.doiTuongViPhams[params.doiTuongViPhams.length] = {
        id: item.doiTuongViPhamId
      }
    })
    ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
      Toastr('Xóa tất cả đối tượng vi phạm thành công', 'success');
      this.getListDaTa();
    });
  }

  clearData() {
    let params = {doiTuongViPhams: []}
    this.state.dataDoiTuongViPham.map(item => {
      params.doiTuongViPhams[params.doiTuongViPhams.length] = {
        id: item.doiTuongViPhamId
      }
    })
    ThanhTra.actions.deleteDoiTuongViPham.request('',params);
  }

  checkSumKienNghi() {
    if (this.state.dataDoiTuongViPham.length > 0) {
      let tongToChucKienNghiXuLyHanhChinh = 0;
      let tongCaNhanKienNghiXuLyHanhChinh = 0;
      let tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
      let tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
      let tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
      let tongSaiPhamVeTienKienNghiXuLyKhac = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
      this.state.dataDoiTuongViPham.map(item => {
        let toChucCoSaiPham = item.toChucCoSaiPham;
        let dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
        if(dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
          tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length
        }
        let caNhanCoSaiPham = item.caNhanCoSaiPham;
        let dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
        if(dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
          tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length
        }
        tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecKienNghiChuyenCoQuanDieuTra;
        tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.tienKienNghiXuLyKhac;
        tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.datKienNghiXuLyKhac;
        tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + item.saiPhamVeTienKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeTienKienNghiKhacXuLyVeKinhTe;
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatKienNghiThuHoiKienNghiXuLyVeKinhTe + item.saiPhamVeDatKienNghiKhacXuLyVeKinhTe;
        if(item.chuyenCoQuanDieuTra) {
          tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + 1;
        }
      })
      this.setState({
        kienNghi: {
          tongToChucKienNghiXuLyHanhChinh: tongToChucKienNghiXuLyHanhChinh,
          tongCaNhanKienNghiXuLyHanhChinh: tongCaNhanKienNghiXuLyHanhChinh,
          tongSaiPhamVeTienKienNghiXuLyKinhTe: tongSaiPhamVeTienKienNghiXuLyKinhTe,
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: tongSaiPhamVeDatDaiKienNghiXuLyKinhTe,
          tongVuViecKienNghiChuyenCoQuanDieuTra: tongVuViecKienNghiChuyenCoQuanDieuTra,
          tongDoiTuongKienNghiChuyenCoQuanDieuTra: tongDoiTuongKienNghiChuyenCoQuanDieuTra,
          tongSaiPhamVeTienKienNghiXuLyKhac: tongSaiPhamVeTienKienNghiXuLyKhac,
          tongSaiPhamVeDatDaiKienNghiXuLyKhac: tongSaiPhamVeDatDaiKienNghiXuLyKhac,
        }
      })
    } else {
      this.setState({
        kienNghi: {
          tongToChucKienNghiXuLyHanhChinh: 0,
          tongCaNhanKienNghiXuLyHanhChinh: 0,
          tongSaiPhamVeTienKienNghiXuLyKinhTe: 0,
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: 0,
          tongVuViecKienNghiChuyenCoQuanDieuTra: 0,
          tongDoiTuongKienNghiChuyenCoQuanDieuTra: 0,
          tongSaiPhamVeTienKienNghiXuLyKhac: 0,
          tongSaiPhamVeDatDaiKienNghiXuLyKhac: 0,
        }
      })
    }
  }

  checkSumTheoDoi() {
    if (this.state.dataDoiTuongViPham.length > 0) {
      let tongToChucKienNghiXuLyHanhChinh = 0;
      let tongCaNhanKienNghiXuLyHanhChinh = 0;
      let tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
      let tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
      let tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
      let tongSaiPhamVeTienKienNghiXuLyKhac = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
      this.state.dataDoiTuongViPham.map(item => {
        let toChucCoSaiPham = item.theoDoiToChucCoSaiPham ? item.theoDoiToChucCoSaiPham : '';
        let dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
        if(dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
          tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length
        }
        let caNhanCoSaiPham = item.theoDoiCaNhanCoSaiPham ? item.theoDoiCaNhanCoSaiPham : '';
        let dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
        if(dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
          tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length
        }

        let tongDoiTuongKienNghi = item.soDoiTuongTheoDoiXuLyHinhSu ? item.soDoiTuongTheoDoiXuLyHinhSu : '';
        let dataDoiTuongKienNghi = tongDoiTuongKienNghi.split('; ');
        if(dataDoiTuongKienNghi.length > 0 && dataDoiTuongKienNghi[0] != '') {
          tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + dataDoiTuongKienNghi.length
        }

        let saiPhamVeTienKienNghiXuLyKinhTe = 0;
        if(item.listTheoDoiLanNopTien.length > 0) {
          item.listTheoDoiLanNopTien.map(items => {
            saiPhamVeTienKienNghiXuLyKinhTe = saiPhamVeTienKienNghiXuLyKinhTe + items.soTien;
          })
        }

        tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecTheoDoiXuLyHinhSu;
        tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.kienNghiTienTheoDoiXuLyKhac;
        tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.kienNghiDatTheoDoiXuLyKhac;
        tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + saiPhamVeTienKienNghiXuLyKinhTe;
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe;
      })
      this.state.theoDoi.tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh;
      this.state.theoDoi.tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh;
      this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe;
      this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe;
      this.state.theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra;
      this.state.theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra;
      this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac;
      this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac;
      this.setState({
        ...this.state
      }, () => {
        this.checkSumTheoDoiCoQuan();
      })
    } else {
      this.state.theoDoi.tongToChucKienNghiXuLyHanhChinh = 0;
      this.state.theoDoi.tongCaNhanKienNghiXuLyHanhChinh = 0;
      this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
      this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
      this.state.theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
      this.state.theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
      this.state.theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac = 0;
      this.state.theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
      this.setState({
        ...this.state
      }, () => {
        this.checkSumTheoDoiCoQuan();
      })
    }
  }

  checkSumTheoDoiCoQuan() {
    if (this.state.dataCoQuanToChuc.length > 0) {
      let tongToChucKienNghiXuLyHanhChinh = 0;
      let tongCaNhanKienNghiXuLyHanhChinh = 0;
      let tongSaiPhamVeTienKienNghiXuLyKinhTe = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = 0;
      let tongVuViecKienNghiChuyenCoQuanDieuTra = 0;
      let tongDoiTuongKienNghiChuyenCoQuanDieuTra = 0;
      let tongSaiPhamVeTienKienNghiXuLyKhac = 0;
      let tongSaiPhamVeDatDaiKienNghiXuLyKhac = 0;
      this.state.dataCoQuanToChuc.map(item => {
        let toChucCoSaiPham = item.theoDoiToChucCoSaiPham ? item.theoDoiToChucCoSaiPham : '';
        let dataToChucCoSaiPham = toChucCoSaiPham.split('; ');
        if(dataToChucCoSaiPham.length > 0 && dataToChucCoSaiPham[0] != '') {
          tongToChucKienNghiXuLyHanhChinh = tongToChucKienNghiXuLyHanhChinh + dataToChucCoSaiPham.length
        }
        let caNhanCoSaiPham = item.theoDoiCaNhanCoSaiPham ? item.theoDoiCaNhanCoSaiPham : '';
        let dataCaNhanCoSaiPham = caNhanCoSaiPham.split('; ');
        if(dataCaNhanCoSaiPham.length > 0 && dataCaNhanCoSaiPham[0] != '') {
          tongCaNhanKienNghiXuLyHanhChinh = tongCaNhanKienNghiXuLyHanhChinh + dataCaNhanCoSaiPham.length
        }

        let tongDoiTuongKienNghi = item.soDoiTuongTheoDoiXuLyHinhSu ? item.soDoiTuongTheoDoiXuLyHinhSu : '';
        let dataDoiTuongKienNghi = tongDoiTuongKienNghi.split('; ');
        if(dataDoiTuongKienNghi.length > 0 && dataDoiTuongKienNghi[0] != '') {
          tongDoiTuongKienNghiChuyenCoQuanDieuTra = tongDoiTuongKienNghiChuyenCoQuanDieuTra + dataDoiTuongKienNghi.length
        }

        let saiPhamVeTienKienNghiXuLyKinhTe = 0;
        if(item.listTheoDoiLanNopTien.length > 0) {
          item.listTheoDoiLanNopTien.map(items => {
            saiPhamVeTienKienNghiXuLyKinhTe = saiPhamVeTienKienNghiXuLyKinhTe + items.soTien;
          })
        }

        tongVuViecKienNghiChuyenCoQuanDieuTra = tongVuViecKienNghiChuyenCoQuanDieuTra + item.soVuViecTheoDoiXuLyHinhSu;
        tongSaiPhamVeTienKienNghiXuLyKhac = tongSaiPhamVeTienKienNghiXuLyKhac + item.kienNghiTienTheoDoiXuLyKhac;
        tongSaiPhamVeDatDaiKienNghiXuLyKhac = tongSaiPhamVeDatDaiKienNghiXuLyKhac + item.kienNghiDatTheoDoiXuLyKhac;
        tongSaiPhamVeTienKienNghiXuLyKinhTe = tongSaiPhamVeTienKienNghiXuLyKinhTe + saiPhamVeTienKienNghiXuLyKinhTe;
        tongSaiPhamVeDatDaiKienNghiXuLyKinhTe = tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + item.saiPhamVeDatDaiDaThuTheoDoiXuLyVeKinhTe;
      })
      let theoDoi = this.state.theoDoi;
      this.setState({
        theoDoi: {
          tongToChucKienNghiXuLyHanhChinh: Number(theoDoi.tongToChucKienNghiXuLyHanhChinh + tongToChucKienNghiXuLyHanhChinh),
          tongCaNhanKienNghiXuLyHanhChinh: Number(theoDoi.tongCaNhanKienNghiXuLyHanhChinh + tongCaNhanKienNghiXuLyHanhChinh),
          tongSaiPhamVeTienKienNghiXuLyKinhTe: Number(theoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe + tongSaiPhamVeTienKienNghiXuLyKinhTe),
          tongSaiPhamVeDatDaiKienNghiXuLyKinhTe: Number(theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe + tongSaiPhamVeDatDaiKienNghiXuLyKinhTe),
          tongVuViecKienNghiChuyenCoQuanDieuTra: Number(theoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra + tongVuViecKienNghiChuyenCoQuanDieuTra),
          tongDoiTuongKienNghiChuyenCoQuanDieuTra: Number(theoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra + tongDoiTuongKienNghiChuyenCoQuanDieuTra),
          tongSaiPhamVeTienKienNghiXuLyKhac: Number(theoDoi.tongSaiPhamVeTienKienNghiXuLyKhac + tongSaiPhamVeTienKienNghiXuLyKhac),
          tongSaiPhamVeDatDaiKienNghiXuLyKhac: Number(theoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac + tongSaiPhamVeDatDaiKienNghiXuLyKhac),
        }
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.type != nextProps.type) {
      this.setState({
        type: nextProps.type
      })
    }
  }

  closeDialog(name) {
    this.setState({
      [name]: false
    })
  }

  handleEditDoiTuongKienNghi(id) {
    this.setState({
      idEdit: id,
    },()=> {
      this.setState({
        showDoiTuongKienNghi: true
      })
    })
  }
  handleEditToChucLienQuan(id) {
    this.setState({
      idEdit: id,
      titleDialog: 'Chỉnh sửa cơ quan, tổ chức có liên quan'
    },()=> {
      this.setState({
        showToChucLienQuan: true
      })
    })
  }
  handleAddMore() {
    this.setState({
      idEdit: null,
      titleDialog: 'Thêm mới cơ quan, tổ chức có liên quan'
    },()=> {
      this.setState({
        showToChucLienQuan: true
      })
    })
  }

  handleDelete(sID) {
    let params = {
      doiTuongViPhams: [
        {
          id: sID
        }
      ]
    }
    ThanhTra.actions.deleteDoiTuongViPham.request('',params).then(res => {
      Toastr('Xóa đối tượng vi phạm thành công', 'success');
      this.getListDaTaCoQuanToChuc();
    });
  }

  render() {
    let KienNghi = this.state.kienNghi;
    let TheoDoi = this.state.theoDoi;
    return (
      <div className="row pl10 pr10">
        <div className='block-gray col-100 p15 pb0 mb20'>
          <h2 className='col-100 mb10 title-12'>Kết quả kiến nghị</h2>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
            <Text className="col-100" label="Số đơn vị vi phạm/đơn vị liên quan:" value={this.state.dataDoiTuongViPham.length + '/' + this.props.listDoiTuongViPham.length}/>
          </div>
          <div className="col-50 no-gutter mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý hành chính</p>
            <Text className="col-50" label="Tổng tổ chức:" value={KienNghi.tongToChucKienNghiXuLyHanhChinh ? String(KienNghi.tongToChucKienNghiXuLyHanhChinh) : '0'}/>
            <Text className="col-50" label="Tổng cá nhân:" value={KienNghi.tongCaNhanKienNghiXuLyHanhChinh ? String(KienNghi.tongCaNhanKienNghiXuLyHanhChinh) : '0'}/>
          </div>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý kinh tế</p>
            <Text className="col-50" label="Sai phạm về tiền (đ):" value={KienNghi.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(KienNghi.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0'}/>
            <Text className="col-50" label="Sai phạm về đất đai (m2):" value={KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0'}/>
          </div>
          <div className="col-50 no-gutter mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị chuyển cơ quan điều tra</p>
            <Text className="col-50" label="Số vụ việc:" value={KienNghi.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(KienNghi.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0'}/>
            <Text className="col-50" label="Đối tượng:" value={KienNghi.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(KienNghi.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0'}/>
          </div>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý khác</p>
            <Text className="col-50" label="Sai phạm về tiền (đ):" value={KienNghi.tongSaiPhamVeTienKienNghiXuLyKhac ? String(KienNghi.tongSaiPhamVeTienKienNghiXuLyKhac) : '0'}/>
            <Text className="col-50" label="Sai phạm về đất đai (m2):" value={KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(KienNghi.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0'}/>
          </div>
        </div>

        <div className='block-gray col-100 p15 pb0 mb20'>
          <h2 className='col-100 mb10 title-12'>Kết quả theo dõi</h2>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Tổng vi phạm</p>
            <Text className="col-100" label="Số đơn vị vi phạm/đơn vị liên quan:" value={(this.state.dataCoQuanToChuc.length + this.state.dataDoiTuongViPham.length) + '/' + (this.props.listDoiTuongViPham.length + this.state.dataCoQuanToChuc.length)}/>
          </div>
          <div className="col-50 no-gutter mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý hành chính</p>
            <Text className="col-50" label="Tổng tổ chức:" value={TheoDoi.tongToChucKienNghiXuLyHanhChinh ? String(TheoDoi.tongToChucKienNghiXuLyHanhChinh) : '0'}/>
            <Text className="col-50" label="Tổng cá nhân:" value={TheoDoi.tongCaNhanKienNghiXuLyHanhChinh ? String(TheoDoi.tongCaNhanKienNghiXuLyHanhChinh) : '0'}/>
          </div>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý kinh tế</p>
            <Text className="col-50" label="Sai phạm về tiền (đ):" value={TheoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe ? String(TheoDoi.tongSaiPhamVeTienKienNghiXuLyKinhTe) : '0'}/>
            <Text className="col-50" label="Sai phạm về đất đai (m2):" value={TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe ? String(TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKinhTe) : '0'}/>
          </div>
          <div className="col-50 no-gutter mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị chuyển cơ quan điều tra</p>
            <Text className="col-50" label="Số vụ việc:" value={TheoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra ? String(TheoDoi.tongVuViecKienNghiChuyenCoQuanDieuTra) : '0'}/>
            <Text className="col-50" label="Đối tượng:" value={TheoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra ? String(TheoDoi.tongDoiTuongKienNghiChuyenCoQuanDieuTra) : '0'}/>
          </div>
          <div className="col-50 no-gutter clear-left mb10">
            <p className="txt-bold txt-upper mb10 pl5 pr5">Kiến nghị xử lý khác</p>
            <Text className="col-50" label="Sai phạm về tiền (đ):" value={TheoDoi.tongSaiPhamVeTienKienNghiXuLyKhac ? String(TheoDoi.tongSaiPhamVeTienKienNghiXuLyKhac) : '0'}/>
            <Text className="col-50" label="Sai phạm về đất đai (m2):" value={TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac ? String(TheoDoi.tongSaiPhamVeDatDaiKienNghiXuLyKhac) : '0'}/>
          </div>
        </div>

        <div className='col-100'>
          <h2 className='txt-bold txt-upper'>Đối tượng</h2>
        </div>
        <div className='col-100 no-gutter'>
          <div className='row white-table'>
            <DataTable
              header={header.theoDoiThucHien.danhSachDoiTuongViPham}
              dataList={this.state.dataDoiTuongViPham}
              pageData={this.state.pageData}
              parent={this}
              hideButtonExport
              hidePagination={true}
              showAddMore={false}
              search={true}
              tableLoading={this.state.tableLoading}>
                { this.props.view === true ? (
                  <RowItemDoiTuongThanhTraView chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} toChucLienQuan={false} linhVucThanhTra={this.props.linhVucThanhTra} handleEdit={this.handleEditToChucLienQuan.bind(this)}/>
                ) : (
                  <RowItemDoiTuongThanhTra handleEdit={this.handleEditDoiTuongKienNghi.bind(this)}/>
                )}
            </DataTable>
          </div>
        </div>

        <div className='col-100'>
          <h2 className='txt-bold txt-upper'>Cơ quan tổ chức liên quan</h2>
        </div>
        <div className='col-100 no-gutter'>
          <div className='row white-table'>
            <DataTable
              header={header.theoDoiThucHien.danhSachDoiTuongViPham}
              dataList={this.state.dataCoQuanToChuc}
              pageData={this.state.pageData}
              parent={this}
              hideButtonExport
              hidePagination={true}
              titleAddmore='Thêm mới cơ quan, tổ chức có liên quan'
              addMore={this.handleAddMore.bind(this)}
              showAddMore={this.props.view ? false : true}
              search={this.props.view ? true : this.state.search}
              tableLoading={this.state.tableLoading}>
                { this.props.view === true ? (
                  <RowItemDoiTuongThanhTraView chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} linhVucThanhTra={this.props.linhVucThanhTra} toChucLienQuan={true} handleEdit={this.handleEditToChucLienQuan.bind(this)}/>
                ) : (
                  <RowItemDoiTuongThanhTra enableDelete={true} toChucLienQuan={true} handleEdit={this.handleEditToChucLienQuan.bind(this)}/>
                )}
            </DataTable>
          </div>
        </div>
        <DoiTuongKienNghi onClose={this.closeDialog.bind(this, 'showDoiTuongKienNghi')} isOpen={this.state.showDoiTuongKienNghi} id={this.state.idEdit} getListDaTa={this.getListDaTaDoiTuongViPham.bind(this)} chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} idCuocThanhTra={this.props.id} listDoiTuongViPham={this.props.listDoiTuongViPham} closeDialog={this.closeDialog.bind(this, 'showDoiTuongKienNghi')} linhVucThanhTra={this.props.linhVucThanhTra}/>
        <ToChucLienQuan title={this.state.titleDialog} onClose={this.closeDialog.bind(this, 'showToChucLienQuan')} isOpen={this.state.showToChucLienQuan} id={this.state.idEdit} getListDaTa={this.getListDaTaCoQuanToChuc.bind(this)} chucNangCuocThanhTra={this.props.chucNangCuocThanhTra} idCuocThanhTra={this.props.id} listDoiTuongViPham={this.props.listDoiTuongViPham} closeDialog={this.closeDialog.bind(this, 'showToChucLienQuan')} linhVucThanhTra={this.props.linhVucThanhTra}/>
      </div>
    );
  }
}

NoiDungKienNghi.defaultProps = {
  listDoiTuongThanhTra: [],
  listDoiTuongViPham: [],
  dataDoiTuongViPham: [],
  setDoiTuongViPhamHienTai: function() {
  },
  view: false,
  setCountDoiTuongViPham: function() {}
}

export default NoiDungKienNghi;


// WEBPACK FOOTER //
// ./src/components/modules/theo-doi-thuc-hien/sub-view/NoiDungKienNghi.jsx